import { render } from "./SurveyResult.vue?vue&type=template&id=c2205e94&scoped=true"
import script from "./SurveyResult.vue?vue&type=script&lang=js"
export * from "./SurveyResult.vue?vue&type=script&lang=js"

import "./SurveyResult.vue?vue&type=style&index=0&id=c2205e94&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2205e94"]])

export default __exports__